import { IBugsnagService } from "./IBugsnagService";

export class BugsnagService implements IBugsnagService {
	private readonly _metaKey: HTMLMetaElement;
	private readonly _metaVersion: HTMLMetaElement;

	constructor() {
		this._metaKey = document.querySelector(
			"meta[name='bsk']"
		) as HTMLMetaElement;

		this._metaVersion = document.querySelector(
			"meta[name='bskv']"
		) as HTMLMetaElement;
	}

	clearApiKey(): void {
		if (this._metaKey) {
			this._metaKey.content = "";
		}
	}

	getApiKey(): string {
		return this._metaKey?.content;
	}

	getReleaseVersion(): string {
		return this._metaVersion?.content;
	}

	hasApiKey(): boolean {
		if (this._metaKey?.content) {
			return true;
		}

		return false;
	}
}
